<template>
  <v-menu close-on-content-click
          open-on-hover offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        class="normal-btn-text ml-2 mb-3 rounded-tag-small elevation-0"
        v-on="on">
        {{ description }}
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-for="option in options"
                   :key="option.key"
                   @click="selectOption(option)">
        <v-list-item-content>
          <v-list-item-title>
            {{ option.description }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import CotacaoViewOptions from '@/enums/cotacao-view-options';

export default {
  props: {
    value: String,
  },
  data() {
    return {
      options: CotacaoViewOptions.values,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    description() {
      if (!this.localValue) {
        return CotacaoViewOptions.keys.POR_COTACAO.description;
      }
      return CotacaoViewOptions.keys[this.localValue].description;
    },
  },
  methods: {
    selectOption(option) {
      this.localValue = option.key;
      this.$emit('change', option.key);
    },
  },
  created() {
    this.localValue = this.localValue ?? CotacaoViewOptions.keys.POR_COTACAO.key;
  },
};
</script>
